module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition-group', {
    staticClass: "i-upload-files",
    attrs: {
      "tag": "ul",
      "name": "list"
    }
  }, _vm._l((_vm.files), function(file) {
    return _c('li', {
      key: file,
      staticClass: "i-upload-file",
      class: {
        'is-finished': file.status === 'finished'
      },
      on: {
        "click": function($event) {
          _vm.$emit('clickFile', file)
        }
      }
    }, [_c('a', {
      staticClass: "i-upload-file-name",
      on: {
        "click": function($event) {
          _vm.$emit('preview', file)
        }
      }
    }, [_c('i', {
      staticClass: "i-icon-document"
    }), _vm._v(_vm._s(file.name) + "\n        ")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (file.status === 'finished'),
        expression: "file.status === 'finished'"
      }],
      staticClass: "i-upload-btn-delete",
      on: {
        "click": function($event) {
          _vm.$emit('remove', file)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('el.upload.delete')))]), _vm._v(" "), (file.showProgress) ? _c('i-progress', {
      attrs: {
        "stroke-width": 2,
        "percentage": _vm.parsePercentage(file.percentage),
        "status": file.status === 'finished' && file.showProgress ? 'success' : ''
      }
    }) : _vm._e()], 1)
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-995b67b0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/upload/src/upload-list.vue
// module id = 668
// module chunks = 0